"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsEscalationLevelTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _dmsbasereact = require("dmsbasereact");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsEscalationLevelTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Policy").d("Policy"),
    column_name: "policy_pk",
    control: 'select',
    url: "/escalation_policy/all",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("LevelNumber").d("Level Number"),
    column_name: "level_number",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Role").d("Role"),
    column_name: "role_pk",
    control: 'select',
    url: "/role/all",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("TriggerDelay").d("Trigger Delay"),
    column_name: "trigger_delay",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("EscalationDelay").d("Escalation Delay"),
    column_name: "escalation_delay",
    filter: true
  }];
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: "/escalation_level/table",
    export_table: false,
    responsive: true
  });
};
exports.DmsEscalationLevelTable = DmsEscalationLevelTable;